// extracted by mini-css-extract-plugin
export default {"mic_speech":"microspeech_mic_speech__8UcOu"};